import React, { useState } from "react";
import "./BloodDonation.css";
import { Link } from "react-router";

const BloodDonation = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="blood-donation-wrapper py-5">
      <div className="blood-donation-card container-fluid p-5 rounded shadow-lg">
        <div className="row align-items-center">
          {/* Left Section */}
          <div className="col-lg-6">
            <h2 className="blood-donation-heading display-5 fw-bold text-danger">
              🩸 Give the Gift of Life
            </h2>
            <p className="blood-donation-subheading fs-5 text-dark">
              The blood you donate gives someone another chance at life 🙏
            </p>
            <button
              className="btn btn-danger btn-lg mt-3"
              onClick={() => setShowModal(true)}
            >
              Become a Donor ❤️
            </button>
          </div>

          {/* Right Section */}
          <div className="col-lg-6 text-center mt-4 mt-lg-0">
            <img
              src="/assets/img/m-blood/blood-hand.png"
              alt="Support and education symbol"
              className="img-fluid"
              style={{ maxHeight: "350px", borderRadius: "12px" }}
            />
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">🩸 Join Our Lifesavers</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Every drop counts! Your decision to donate can change lives. 🌟
                </p>
              </div>
              <div className="modal-footer">
                <Link to="/apply-dbd" className="btn btn-primary">
                  Proceed to Join 🚀
                </Link>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BloodDonation;
